var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinivanBlueBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 114,
    viewBox: "0 0 165 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minivan-blue-bg",
    transform: "translate(-219 -1198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 165,
    height: 114,
    rx: 20,
    transform: "translate(219 1198)",
    fill: "#04a8e8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Mini_van",
    "data-name": "Mini van",
    transform: "translate(268 1289)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600,
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MINI VAN")), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(-1125.298 -1477.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M1479.075,2742.529c-.665-10.543-4.9-15.576-12.4-15.07-7.456.5-11.139,6.216-10.24,16.378h-54.757c1.419-4.781,1.06-9.2-2.517-12.875a11.117,11.117,0,0,0-8.253-3.511c-7.286,0-11.73,5.663-11.436,14.57-4.892,1.732-7.1.4-7.682-4.481-.6-5.082,2.214-9.163,3.842-13.588a3.638,3.638,0,0,1,2.558-1.965c12.476-3.6,23.528-10.2,34.791-16.371,4.625-2.536,9.73-3.339,14.973-3.378q23.258-.171,46.515-.382c2.24-.019,3.819.019,4.9,2.914,1.109,2.973,3.2,5.708,4.709,8.644a43.971,43.971,0,0,1,5.237,17.525c.146,2.331,1.277,4.675,1.02,7.239-.235,2.351-1.264,3.626-3.618,3.887C1484.243,2742.338,1481.791,2743.059,1479.075,2742.529Zm-71.318-24.344c6.8,0,13.267,0,19.737,0a2.007,2.007,0,0,0,2.3-1.849c.449-3.54.863-7.084,1.306-10.754-10.671-1.4-18.979,2.767-27.318,9.19C1406.816,2715.063,1408.358,2715.967,1407.757,2718.185Zm25.437-.669c6.273,0,12.265,0,18.258,0,1.242,0,1.741-.657,1.682-1.875-.139-2.847-.285-5.691-.333-8.54-.027-1.6-.792-2.051-2.275-2.024-4.71.092-9.422.1-14.134.138-1.08.007-1.983.257-2.145,1.521A74.684,74.684,0,0,0,1433.194,2717.516Zm43.91-1.153c.055-.846.145-1.091.071-1.268-2.8-6.564-13.56-11.68-20.189-9.65-.877.269-1.36.744-1.316,1.608.173,3.359-.063,6.752.711,10.463Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M1488.013,2743.095c.069,4.495-4.278,8.873-8.833,8.894-4.624.021-8.919-4.41-8.919-9.2a8.952,8.952,0,0,1,8.764-8.856C1484.13,2733.864,1487.931,2737.738,1488.013,2743.095Z",
    transform: "translate(-11.706 -3.81)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M1383.515,2743.441c.124-5.671,3.993-9.719,9.1-9.521a8.858,8.858,0,0,1,8.606,9.013,9.069,9.069,0,0,1-9.019,8.957C1387.908,2751.847,1383.427,2747.487,1383.515,2743.441Z",
    transform: "translate(-1.402 -3.808)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinivanBlueBg);
export default __webpack_public_path__ + "static/media/minivan-blue-bg.0384e1b0ed3b2a1ad2d8ccb76b33e903.svg";
export { ForwardRef as ReactComponent };